import { type WrappedInsightHeroMarketContextAttributes } from "@clipboard-health/contract-backend-main";
import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import ReactConfetti from "react-confetti";

import { Button } from "../../../components/Button";
import { PageFooterWrapper } from "../../../components/PageFooterWrapper";

interface HeroMarketContextContentProps {
  attributes: WrappedInsightHeroMarketContextAttributes;
  onNext?: () => void;
  isPreview?: boolean;
}

interface StatItemProps {
  value: number | string;
  label: string;
}

function StatItem(props: StatItemProps) {
  const { value, label } = props;

  return (
    <Box>
      <Text variant="h2" color="white">
        {value}
      </Text>
      <Text variant="body2" color="white">
        {label}
      </Text>
    </Box>
  );
}

export function HeroMarketContextContent(props: HeroMarketContextContentProps) {
  const { attributes, onNext, isPreview = false } = props;

  return (
    <>
      {!isPreview && (
        <ReactConfetti
          data-hide-on-screenshot
          recycle
          width={window.innerWidth}
          height={window.innerHeight}
          numberOfPieces={100}
          style={{ position: "absolute", top: 0, left: 0, pointerEvents: "none" }}
        />
      )}

      <Stack flex={1} paddingX={7} paddingY={6} justifyContent="center" gap={10}>
        {/* Year Title */}
        <Box>
          <Text variant="h1" color="white" sx={{ fontSize: "5rem" }}>
            2025
          </Text>
          <Text variant="h3" color="white">
            Year in review
          </Text>
        </Box>

        {/* Stats */}
        <Stack gap={3}>
          <StatItem
            value={attributes.numberOfProfessionals.toLocaleString()}
            label="professionals on Clipboard"
          />
          <StatItem
            value={attributes.numberOfShiftTypesWorked}
            label="different types of shifts worked"
          />
          <StatItem value={attributes.numberOfWorkplaces} label="different workplaces" />
        </Stack>

        {/* Bottom Message */}
        <Text variant="body2" color="white">
          This year, over 2.5 million shifts were completed — but your journey was special.
        </Text>
      </Stack>

      {!isPreview && onNext && (
        <PageFooterWrapper>
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onNext();
            }}
          >
            Let&apos;s see!
          </Button>
        </PageFooterWrapper>
      )}
    </>
  );
}
